export default function Sources({ links }) {
  if (!links || links.length === 0) return null;

  return (
    <footer className="mt-12 pt-6 border-t border-[#E4E1D8] text-[14px] text-[#5C636B]">
      <p className="font-semibold text-[#2E3A46] mb-2 font-mono uppercase tracking-wider text-[12px]">
        Kilder:
      </p>
      <ul className="space-y-1.5 list-none p-0 m-0">
        {links.map((link, idx) => (
          <li key={idx} className="flex items-baseline gap-2">
            <span className="text-[#B58200]" aria-hidden="true">—</span>
            <a 
              href={link.url} 
              target="_blank" 
              rel="noopener noreferrer" 
              className="text-[#2E3A46] hover:text-[#B58200] hover:underline underline-offset-2 break-all"
            >
              {link.title} ({link.source})
            </a>
          </li>
        ))}
      </ul>
    </footer>
  );
}
